.tab[data-variant='none'],
.tab[data-variant='default'] {
  background-color: white;
  color: #667085;
  &[data-active] {
    background-color: #f2f4f7;
    color: black;
    padding: 8px 14px;
  }
  padding: 8px 14px;
}

.tab[data-variant='section'] {
  color: #667085;
  font-weight: 600;
  padding: 8px 12px;
  &[data-active] {
    background-color: var(--mantine-color-brand-1);
    color: var(--mantine-color-brand-8);
    border-radius: 6px;
  }
}

/* WARNING: if you change this make sure to change the accordion variant vertical-tabs as well to match*/
.tab[data-variant='vertical'] {
  color: var(--mantine-color-gray-7);
  font-weight: 600;
  font-size: 16px;
  padding: 0 var(--mantine-spacing-xxs);
  margin-bottom: var(--mantine-spacing-xs);
  line-height: 24px;
  border-radius: 4px;
  justify-content: flex-start;

  &[data-active] {
    background-color: var(--mantine-color-orange-1);
    color: var(--mantine-color-gray-10);
  }
}

.tab[data-variant='vertical']:last-child {
  margin-bottom: 0;
}

.header {
  background-color: #f2f4f7;
}

.header:first-child {
  border-top-left-radius: var(--mantine-radius-lg);
}

.header:last-child {
  border-top-right-radius: var(--mantine-radius-lg);
}

.inputLabel {
  color: var(--mantine-color-gray-10);
  margin-bottom: var(--mantine-spacing-xxxs);
  font-weight: 700;
}

.inputWrapper {
  &[data-disabled] {
    background-color: var(--mantine-color-gray-2);
  }
}

.input {
  border: 1px solid var(--mantine-color-gray-3);
  padding-right: 14px;
  padding-left: 32px;
}
.inputLabel[data-variant='light'] {
  font-size: var(--mantine-font-size-sm);
  color: var(--mantine-color-gray-7);
}

.input[data-variant='match-none'] {
  border-color: var(--mantine-color-gray-5);
}

.input[data-variant='inline'] {
  border: none;
  padding-right: 0;
  padding-left: 0;
  --input-height: 21px;
  height: 21px;
  field-sizing: content;
  min-width: 60px;
  font-size: var(--mantine-font-size-sm);
  font-weight: 500;
  background-color: transparent;
}

[data-position='left'] + .input[data-variant='inline'] {
  padding-left: 32px;
}

.input[data-variant='default']:not([data-position='left'] + .input) {
  padding-left: 14px;
}

.input[data-variant='inline']:not([data-position='left'] + .input) {
  padding-left: 0;
}

.input[data-variant='match-possible-new'] {
  border-color: var(--mantine-color-blue-9);
  background-color: var(--mantine-color-blue-0);
}

.input[data-variant='match-match'] {
  border-color: var(--mantine-color-gray-5);
}

.input[data-variant='compact'] {
  --input-size: 40px;
  border-radius: 8px;
  border: 1px solid var(--mantine-color-gray-4);
}

.input[data-variant='search'] {
  --input-size: 40px;
  border-radius: 12px;
  border: 1px solid var(--mantine-color-gray-4);
  background-color: var(--mantine-color-white);
}

.actionIconRoot {
  border-radius: 8px;
}

.thead {
  background-color: var(--mantine-color-gray-2);
  color: var(--mantine-color-gray-8);
}

.th:first-child {
  border-radius: 10px 0 0 0;
}

.th:last-child {
  border-radius: 0 10px 0 0;
}

.selectOption:hover {
  background-color: var(--mantine-color-gray-2);
}

table[data-variant='bare'] {
  th:first-child {
    border-radius: 0;
  }

  th:last-child {
    border-radius: 0;
  }

  th {
    font-weight: 600;
    font-size: var(--mantine-font-size-xs);
  }

  thead {
    border-radius: 0;
    background-color: transparent;
  }
}

table[data-variant='accordion-table'] {
  thead {
    background-color: transparent;
  }

  th {
    background-color: var(--mantine-color-gray-1);
  }

  th:nth-child(1) {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    -moz-border-radius: 8px 0 0 8px;
  }

  th:nth-last-child(1) {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    -moz-border-radius: 0 8px 8px 0;
  }

  th {
    padding-top: var(--mantine-spacing-xxs);
    padding-bottom: var(--mantine-spacing-xxs);
    color: var(--mantine-color-gray-9);
    font-weight: 500;
    font-size: 13px;
    border-bottom: none;
  }

  td {
    padding-top: var(--mantine-spacing-xs);
    padding-bottom: var(--mantine-spacing-xs);
    font-size: 14px;
    color: var(--mantine-color-gray-9);
    font-weight: 500;
    position: relative;
  }

  tbody tr {
    border-bottom: 1px solid var(--mantine-color-gray-1);
    position: relative;
  }

  tbody tr:last-child {
    border-bottom: none;
  }

  tbody tr:hover {
    box-shadow:
      inset 0 4px 0 white,
      inset 0 -4px 0 white,
      inset 0 0 0 9999px var(--mantine-color-brand-1);
    border-radius: 8px;
  }

  /* hide border on empty row which mantine-datatablre inserts with a single empty td */
  tr:has(td:first-child:last-child) {
    border-bottom: none;
  }
}

table[data-variant='cashflows-table'] {
  thead {
    background-color: transparent;
  }

  th {
    color: var(--mantine-color-gray-7);
    font-size: var(--mantine-font-size-sm);
    font-weight: 500;
    border-bottom: none;
  }

  td {
    color: var(--mantine-color-gray-10);
    font-size: var(--mantine-font-size-md);
    font-weight: 600;
  }

  tr {
    border-bottom: 1px solid var(--mantine-color-gray-1);
  }

  /* hide border on empty row which mantine-datatablre inserts with a single empty td */
  tr:has(td:first-child:last-child) {
    border-bottom: none;
  }
}

table[data-variant='clients-table'] {
  tr {
    padding: 0;
  }

  thead {
    border-top: 1px solid var(--mantine-color-gray-3);
    border-bottom: 1px solid var(--mantine-color-gray-3);
  }

  th:first-child {
    padding-left: 24px;
  }

  th:last-child {
    padding-right: 24px;
  }

  tbody td {
    padding-top: 16px;
    padding-bottom: 16px;
  }

  tbody td:first-child {
    padding-left: 24px;
  }

  tbody td:last-child {
    padding-right: 24px;
  }

  tr {
    border-bottom: 1px solid var(--mantine-color-gray-3);
  }

  tr.just-added-client {
    animation: highlightFade 2s ease-out;
  }

  tr:hover {
    background-color: var(--mantine-color-gray-0);
  }
}

table[data-variant='form-table'] {
  tr {
    border-bottom: 0;
  }

  th {
    border-bottom: 0;
  }

  th:first-child {
    border-bottom-left-radius: 8px;
    border-top-left-radius: 8px;
  }

  th:last-child {
    border-bottom-right-radius: 8px;
    border-top-right-radius: 8px;
  }

  td {
    padding: var(--mantine-spacing-md) var(--mantine-spacing-xs);
  }
}

@keyframes highlightFade {
  0% {
    background-color: var(--mantine-color-gray-7);
  }
  100% {
    background-color: transparent;
  }
}

.menuDropdown {
  border-radius: var(--mantine-radius-md);
}

.loader {
  color: var(--mantine-color-brand-6);
}
